export const legalNotice = [
  {
    title: '1. Présentation du site.',
    content: `
    En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site  seedoutfenua.com  l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :
    Propriétaire : Médeau Henry
    Créateur : Web Factory
    Responsable publication : Médeau Henry – henrymedeau@gmail.com
    Webmaster : Tirolien Fabrice – tfabrice@live.fr
    Crédits : Vector Icons - Pixabay - Subdelirium
    `
  },
  {
    title: '2. Conditions générales d’utilisation du site et des services proposés.',
    content: `
    L’utilisation du site seedoutfenua.com implique l’acceptation pleine et entière des conditions générales d’utilisation ci-après décrites. Ces conditions d’utilisation sont susceptibles d’être modifiées ou complétées à tout moment, les utilisateurs du site seedoutfenua.com sont donc invités à les consulter de manière régulière.
    \r\n
    Ce site e<st normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut être toutefois décidée par Médeau Henry, qui s’efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l’intervention.
    \r\n
    Le site seedoutfenua.com est mis à jour régulièrement par Médeau Henry. De la même façon, les mentions légales peuvent être modifiées à tout moment : elles s’imposent néanmoins à l’utilisateur qui est invité à s’y référer le plus souvent possible afin d’en prendre connaissance.
    `
  },
  {
    title: '3. Description des services fournis.',
    content: `
    Le site seedoutfenua.com a pour objet de fournir une information concernant l’ensemble des activités de la société.
    \r\n
    Médeau Henry s’efforce de fournir sur le site seedoutfenua.com des informations aussi précises que possible. Toutefois, il ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
    \r\n
    Tous les informations indiquées sur le site seedoutfenua.com sont données à titre indicatif, et sont susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le site seedoutfenua.com ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
    `
  },
  {
    title: '4. Limitations contractuelles sur les données techniques.',
    content: `
    Le site utilise la technologie JavaScript.
    \r\n
    Le site Internet ne pourra être tenu responsable de dommages matériels liés à l’utilisation du site. De plus, l’utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour
    `
  },
  {
    title: '5. Propriété intellectuelle et contrefaçons.',
    content: `
    En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l'article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995.
    \r\n
    A l'occasion de l'utilisation du site seedoutfenua.com, peuvent êtres recueillies : l'URL des liens par l'intermédiaire desquels l'utilisateur a accédé au site seedoutfenua.com, le fournisseur d'accès de l'utilisateur, l'adresse de protocole Internet (IP) de l'utilisateur.
    \r\n
    En tout état de cause Médeau Henry ne collecte des informations personnelles relatives à l'utilisateur que pour le besoin de certains services proposés par le site seedoutfenua.com. L'utilisateur fournit ces informations en toute connaissance de cause, notamment lorsqu'il procède par lui-même à leur saisie. Il est alors précisé à l'utilisateur du site seedoutfenua.com l’obligation ou non de fournir ces informations.
    \r\n
    Conformément aux dispositions des articles 38 et suivants de la loi 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, tout utilisateur dispose d’un droit d’accès, de rectification et d’opposition aux données personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d’une copie du titre d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être envoyée.
    \r\n
    Aucune information personnelle de l'utilisateur du site seedoutfenua.com n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l'hypothèse du rachat de Médeau Henry et de ses droits permettrait la transmission des dites informations à l'éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des données vis à vis de l'utilisateur du site seedoutfenua.com.
    \r\n
    Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données. exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
    `
  },
  {
    title: '6. mitations de responsabilité.',
    content: `
    Médeau Henry ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site seedoutfenua.com, et résultant soit de l’utilisation d’un matériel ne répondant pas aux spécifications indiquées au point 4, soit de l’apparition d’un bug ou d’une incompatibilité.
    \r\n
    Médeau Henry ne pourra également être tenue responsable des dommages indirects (tels par exemple qu’une perte de marché ou perte d’une chance) consécutifs à l’utilisation du site seedoutfenua.com.
    \r\n
    Des espaces interactifs (possibilité de poser des questions dans l’espace contact) sont à la disposition des utilisateurs. Médeau Henry se réserve le droit de supprimer, sans mise en demeure préalable, tout contenu déposé dans cet espace qui contreviendrait à la législation applicable en France, en particulier aux dispositions relatives à la protection des données. Le cas échéant, Médeau Henry se réserve également la possibilité de mettre en cause la responsabilité civile et/ou pénale de l’utilisateur, notamment en cas de message à caractère raciste, injurieux, diffamant, ou pornographique, quel que soit le support utilisé (texte, photographie…).
    `
  },
  {
    title: '7. Gestion des données personnelles.',
    content: `
    En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l'article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995.
    \r\n
    A l'occasion de l'utilisation du site seedoutfenua.com, peuvent êtres recueillies : l'URL des liens par l'intermédiaire desquels l'utilisateur a accédé au site seedoutfenua.com, le fournisseur d'accès de l'utilisateur, l'adresse de protocole Internet (IP) de l'utilisateur.
    \r\n
    En tout état de cause Médeau Henry ne collecte des informations personnelles relatives à l'utilisateur que pour le besoin de certains services proposés par le site seedoutfenua.com. L'utilisateur fournit ces informations en toute connaissance de cause, notamment lorsqu'il procède par lui-même à leur saisie. Il est alors précisé à l'utilisateur du site seedoutfenua.com l’obligation ou non de fournir ces informations.
    \r\n
    Conformément aux dispositions des articles 38 et suivants de la loi 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, tout utilisateur dispose d’un droit d’accès, de rectification et d’opposition aux données personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d’une copie du titre d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être envoyée.
    \r\n
    Aucune information personnelle de l'utilisateur du site seedoutfenua.com n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l'hypothèse du rachat de Médeau Henry et de ses droits permettrait la transmission des dites informations à l'éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des données vis à vis de l'utilisateur du site seedoutfenua.com.
    \r\n
    Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données. exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
    `
  },
  {
    title: '8. Liens hypertextes et cookies.',
    content: `
    Le site seedoutfenua.com contient un certain nombre de liens hypertextes vers d’autres sites, mis en place avec l’autorisation de Médeau Henry. Cependant, Médeau Henry n’a pas la possibilité de vérifier le contenu des sites ainsi visités, et n’assumera en conséquence aucune responsabilité de ce fait.
    \r\n
    La navigation sur le site seedoutfenua.com est susceptible de provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur. Un cookie est un fichier de petite taille, qui ne permet pas l’identification de l’utilisateur, mais qui enregistre des informations relatives à la navigation d’un ordinateur sur un site. Les données ainsi obtenues visent à faciliter la navigation ultérieure sur le site, et ont également vocation à permettre diverses mesures de fréquentation.
    \r\n
    Le refus d’installation d’un cookie peut entraîner l’impossibilité d’accéder à certains services. L’utilisateur peut toutefois configurer son ordinateur de la manière suivante, pour refuser l’installation des cookies :
    \r\n
    Sous Internet Explorer : onglet outil (pictogramme en forme de rouage en haut a droite) / options internet. Cliquez sur Confidentialité et choisissez Bloquer tous les cookies. Validez sur Ok.
    \r\n
    Sous Firefox : en haut de la fenêtre du navigateur, cliquez sur le bouton Firefox, puis aller dans l'onglet Options. Cliquer sur l'onglet Vie privée. Paramétrez les Règles de conservation sur : utiliser les paramètres personnalisés pour l'historique. Enfin décochez-la pour désactiver les cookies.
    \r\n
    Sous Safari : Cliquez en haut à droite du navigateur sur le pictogramme de menu (symbolisé par un rouage). Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la section "Confidentialité", cliquez sur Paramètres de contenu. Dans la section "Cookies", vous pouvez bloquer les cookies.
    \r\n
    Sous Chrome : Cliquez en haut à droite du navigateur sur le pictogramme de menu (symbolisé par trois lignes horizontales). Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la section "Confidentialité", cliquez sur préférences. Dans l'onglet "Confidentialité", vous pouvez bloquer les cookies.
    `
  },
  {
    title: '9. Droit applicable et attribution de juridiction.',
    content: `
    Tout litige en relation avec l’utilisation du site seedoutfenua.com est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris.
    `
  },
  {
    title: '10. Les principales lois concernées.',
    content: `
    Loi n° 78-17 du 6 janvier 1978, notamment modifiée par la loi n° 2004-801 du 6 août 2004 relative à l'informatique, aux fichiers et aux libertés.
    \r\n
    Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique.
    `
  },
  {
    title: '11. Lexique.',
    content: `
    Utilisateur : Internaute se connectant, utilisant le site susnommé.
    \r\n
    Informations personnelles : « les informations qui permettent, sous quelque forme que ce soit, directement ou non, l'identification des personnes physiques auxquelles elles s'appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).
    `
  }
]

export const partners = [
  {
    title: 'Air Tahiti Nui',
    img: './img/footer/partners/partner_air-tahiti-nui.webp',
    alt: '',
    desc: 'Air Tahiti Nui ou ATN est une compagnie aérienne française basée en Polynésie française. Elle exploite des vols internationaux depuis sa plate-forme de correspondance à l\'aéroport international de Tahiti-Faaa.',
    link: 'https://www.airtahitinui.com/fr-fr',
  },
  {
    title: 'CCISM',
    img: './img/footer/partners/partner_ccism.webp',
    alt: '',
    desc: 'Créer votre business, développer votre entreprise, exporter, vous former, vous informer. La CCISM vous accompagne et vous simplifie la vie d\'entrepreneur.',
    link: 'https://www.ccism.pf',
  },
  {
    title: 'DGEN',
    img: './img/footer/partners/partner_dgen.webp',
    alt: '',
    desc: 'Réaliser toutes études générales et formuler les propositions d’orientation nécessaires à la mise en œuvre des politiques publiques relatives à l’objet du service',
    link: 'https://www.service-public.pf/dgen',
  },
  {
    title: 'French Tech Polynésie',
    img: './img/footer/partners/partner_french-tech-polynesie.webp',
    alt: '',
    desc: 'La French Tech Polynésie est un Hub de l‘innovation PAR et POUR les îles, pour faire émerger, accompagner et propulser à l’international des solutions innovantes.',
    link: 'https://lafrenchtech.com/fr/communaute/polynesie',
  },
  {
    title: 'Tahiti - Le Fenua',
    img: './img/footer/partners/partner_tahiti.webp',
    alt: '',
    desc: 'Tahiti est la plus grande île de la Polynésie française, archipel du sud de l\'océan Pacifique.',
    link: 'https://fr.wikipedia.org/wiki/Tahiti',
  },
  {
    title: 'Game In',
    img: './img/footer/partners/partner_game-in.webp',
    alt: '',
    desc: 'Game IN est une structure capable de créer et d\' entretenir un véritable écosystème et soutenir toutes les démarches privées et publiques concernant le jeu vidéo sous toutes ses formes.',
    link: 'http://www.game-in.org/',
  },
  {
    title: 'PRISM',
    img: './img/footer/partners/partner_prism.webp',
    alt: '',
    desc: 'Incubateur de projets polynésiens, PRISM accompagne les entrepreneurs les plus innovants de Polynésie par un suivi personalisé.',
    link: 'https://www.prism.pf',
  },
  {
    title: 'Plaine Image',
    img: './img/footer/partners/partner_plaine-images.webp',
    alt: '',
    desc: 'Au cœur de l\'Europe, notre écosystème rassemble entreprises, écoles, incubateur, studios. Création de synergies et développement des entreprises !',
    link: 'https://www.plaine-images.fr',
  }
]

export const navigate = [
  {
    name: 'Accueil',
    src: './img/footer/navigate_0.webp',
    alt: 'seedout fenua image du gardien explorateur',
    link : 'home'
  },
  {
    name: 'Votre Impact',
    src: './img/footer/navigate_1.webp',
    alt: 'seedout fenua image du gardien explorateur',
    link : 'your-impact'
  },
  {
    name: 'Pré-commande',
    src: './img/footer/navigate_2.webp',
    alt: 'seedout fenua image du gardien explorateur',
    link : 'game-order'
  },
  {
    name: 'L\'équipe',
    src: './img/footer/navigate_3.webp',
    alt: 'seedout fenua image du gardien explorateur',
    link : 'discover-the-team'
  },
]

export const footer = [
  {
    title: 'Une Famille Unie !',
    img: './img/footer/hero_family.webp',
    alt: 'SeedOut Fenua famille de gardien unie',
  },
  {
    title: 'Telecharger Seedout sur Apple Store',
    img: './img/home/store_apple.webp',
    alt: '"Icone apple store designed by web factory'
  },
  {
    title: 'Telecharger Seedout sur Google Play',
    img: './img/home/store_google.webp',
    alt: 'Icone google play designed by web factory'
  }
]
